<template>
  <div class="container body">
    <div class="main_container">
      <div
        class="col-md-3 left_col no-print"
        style="position: absolute !important"
      >
        <div :class="GetMode()">
          <div
            class="navbar nav_title text-center mt-1 no-print"
            style="border: 0"
          >
            <a
              href="#"
              class="site_title"
              style="overflow: visible !important; line-height: 15px !important"
              ><i
                class="fas fa-home headerlogo"
                style="font-size: 15px !important; overflow: visible !important"
              ></i
              ><span
                style="font-weight: 400 !important; font-size: 11px !important"
              >
                {{ this.$session.get("UserInfoNetPa").customerName }}
              </span>
            </a>
          </div>

          <div class="clearfix"></div>

          <!-- menu profile quick info -->
          <div class="profile clearfix pb-3">
            <div class="row mt-3">
              <div class="col-12 col-md-4 text-center">
                <div class="mt-3" style="margin-right: 30%">
                  <img
                    src="/Template/NewMenu/img/userNew.jpg"
                    alt="..."
                    class="rounded"
                    width="100%"
                  />
                </div>
              </div>

              <div class="col-12 col-md-8 text-center">
                <div class="text-right">
                  <span class="text-light d-block">مشخصات </span>
                  <span class="text-warning">{{
                    this.$session.get("UserInfoNetPa").ozvName +
                    " " +
                    this.$session.get("UserInfoNetPa").ozvFamily
                  }}</span>
                </div>
                <div class="text-right mt-1">
                  <span class="text-light d-block">آخرین ورود</span>
                  <span class="text-warning">{{
                    $session.get("UserInfoNetPa").axarinVorodBeSite
                  }}</span>
                </div>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-12">
                <div class="text-warning text-center pb-3 mt-3">
                  <span class="text-light">آی پی کاربری : </span>{{ UserIp }}
                </div>
              </div>
            </div>
            <div class="row text-center">
              <div class="col-12 text-center">
                <input
                  value="10:00"
                  name="b_Timer"
                  id="b_Timer"
                  style="font-family: IRANSansWeb !important"
                  readonly="true"
                  tabindex="-1"
                  dir="rtl"
                  class="text-center w-100 text-light"
                  title="پس از اين زمان شما بصورت خودکار از سامانه خارج خواهيد شد"
                />
              </div>
            </div>
          </div>

          <!-- /menu profile quick info -->
          <hr />
          <!-- sidebar menu -->
          <div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
            <h3
              style="color: #f38905; font-weight: normal"
              class="text-right mr-2"
            >
              منو سامانه
            </h3>
            <div class="menu_section">
              <ul v-if="render" class="nav side-menu">
                <li style="width: 100%">
                  <router-link :to="{ name: 'Home' }">
                    <i
                      class="fas fa-home"
                      style="font-size: 18px !important; color: #f38905"
                    ></i>
                    <span class="font-small mr-3 text-center text-justify">{{
                      Pishkhan.name
                    }}</span>
                  </router-link>
                </li>
                <!-- راهـــــــــبری پورتال -->
                <li style="width: 100%" v-if="$session.get('IsRahbar')">
                  <a>
                    <i
                      class="fas fa-user-shield"
                      style="font-size: 18px !important; color: #f38905"
                    ></i>
                    <span class="font-small mr-3 text-center matn"
                      >راهبر سیستم</span
                    >
                    <span
                      class="remove-sm fas fa-chevron-down float-left"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li class="sub_menu">
                      <router-link :to="{ name: 'Accessability' }">
                        دسترسی منوها
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'Gateway' }">
                        تنظیمات
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'UsersSetting' }"
                        >بررسی وضعیت کاربران
                      </router-link>
                    </li>
                    <li class="sub_menu" v-if="isWebSiteView">
                      <router-link :to="{ name: 'WebSiteSetting' }"
                        >تنظیمات سایت</router-link
                      >
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'MangeDownloadForms' }"
                        >مدیریت فایلها
                      </router-link>
                    </li>
                    <li
                      v-if="
                        $session.get('IsRahbar') &&
                        $session.get('CustCode') == '801'
                      "
                    >
                      <a href="javascript:;" @click="GotoToTabloo()">
                        <span
                          class="font-small text-justify w-100 mr-3 text-center font-small matn"
                          >ثبت تابلو اعلانات</span
                        >
                      </a>
                    </li>
                    <li v-if="$session.get('IsRahbar')">
                      <router-link :to="{ name: 'SettingVam' }">
                        تنظیمات درخواست وام
                      </router-link>
                    </li>
                    <li v-if="$session.get('IsRahbar')">
                      <router-link :to="{ name: 'FAQManagement' }">
                        پرسش و پاسخ‌های متداول
                      </router-link>
                    </li>
                  </ul>
                </li>
                <!-- درخواســـت ها برای مشتـــری 932 تامین اجتمــاعی -->
                <li
                  style="width: 100%"
                  v-if="
                    $session.get('IsRahbar') &&
                    ($session.get('CustCode') == '932' ||
                      $session.get('CustCode') == '8002')
                  "
                >
                  <a>
                    <i
                      class="fas fa-search"
                      style="font-size: 18px !important; color: #f38905"
                    ></i>
                    <span class="font-small mr-3 text-center matn"
                      >لیست درخواست ها
                    </span>
                    <span
                      class="remove-sm fas fa-chevron-down float-left"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListVamRequests' }">
                        درخواست های وام
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListRegisterRequests' }">
                        درخواست های عضویت
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListRequestLetterEnseraf' }">
                        درخواست های انصراف
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link
                        :to="{ name: 'ListRequestLetterSodorEsterdad' }"
                      >
                        درخواست های استرداد سپرده</router-link
                      >
                    </li>
                    <li class="sub_menu">
                      <router-link
                        :to="{ name: 'ListRequestLetterTaghirAghsat' }"
                      >
                        درخواست های تغییر اقساط
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link
                        :to="{ name: 'ListRequestLetterTaghirModatSepordeh' }"
                      >
                        درخواست های تغییر مدت سپرده
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListAzaFile' }">
                        دریافت فایل
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li style="width: 100%" v-if="$session.get('ModirShobe')">
                  <a>
                    <i
                      class="fas fa-user-shield"
                      style="font-size: 18px !important; color: #f38905"
                    ></i>
                    <span class="font-small mr-3 text-center matn"
                      >مدیر شعبه</span
                    >
                    <span
                      class="remove-sm fas fa-chevron-down float-left"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ManagUsers' }">
                        مدیریت کاربران
                      </router-link>
                    </li>
                    <li
                      v-if="$session.get('UserInfoNetPaModirShobe') != null"
                      class="sub_menu"
                    >
                      <a href="javascript:;" @click="GotoModirShobe()">
                        <span
                          class="font-small text-justify w-100 mr-3 text-center font-small matn"
                          >بازگشت به پنل مدیر</span
                        >
                      </a>
                    </li>
                    <li
                      v-if="
                        $session.get('ModirShobe') &&
                        $session.get('CustCode') == '801'
                      "
                    >
                      <a href="javascript:;" @click="GotoToTabloo()">
                        <span
                          class="font-small text-justify w-100 mr-3 text-center font-small matn"
                          >ثبت تابلو اعلانات</span
                        >
                      </a>
                    </li>
                    <li
                      v-if="
                        $session.get('ModirShobe') &&
                        $session.get('CustCode') == '801'
                      "
                    >
                      <a href="javascript:;" @click="GoToSettingVam()">
                        <span
                          class="font-small text-justify w-100 mr-3 text-center font-small matn"
                          >تنظیمات درخواست وام</span
                        >
                      </a>
                    </li>
                  </ul>
                </li>

                <li
                  v-for="(item, index) in mainMenuLi"
                  :key="index"
                  style="width: 100%"
                >
                  <a>
                    <i
                      :class="item.menuIcone"
                      style="font-size: 18px !important; color: #f38905"
                    ></i>
                    <span
                      class="font-small text-justify w-100 mr-3 text-center font-small matn"
                      >{{ item.name }}</span
                    >
                    <span
                      class="remove-sm fas fa-chevron-down float-left"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li
                      class="sub_menu"
                      v-for="(menu, index) in Getchild(item.id)"
                      :key="index"
                    >
                      <router-link
                        :to="{
                          name: menu.routeName,
                          params: menu.params != null ? menu.params : '',
                        }"
                        >{{ menu.name }}</router-link
                      >
                    </li>
                  </ul>
                </li>
              </ul>
              <div></div>
            </div>
          </div>
          <!-- sidebar menu -->

          <!-- menu footer buttons -->
          <div class="sidebar-footer hidden-small">
            <!-- <a  href="javascript:;" @click.prevent="SettingUser"  title="تنظیمات کاربری">
                            <span class="glyphicon glyphicon-cog" aria-hidden="true"></span>
                        </a>
                        <a href="javascript:;" @click.prevent="FullScreen" title="FullScreen">
                            <span class="glyphicon glyphicon-fullscreen" aria-hidden="true"></span>
                        </a>
                        <a data-toggle="tooltip" data-placement="top" title="Lock">
                            <span class="glyphicon glyphicon-eye-close" aria-hidden="true"></span>
                        </a> -->
            <!-- <a  href="javascript:;" @click.prevent="LogOut()"  title="خروج">
                            <span class="glyphicon glyphicon-off" aria-hidden="true"></span>
                        </a> -->
            <!-- <router-link :to="{name:'TestAxios'}">
                            <span class="glyphicon glyphicon-off" aria-hidden="true"></span>
                        </router-link> -->
          </div>
          <!-- menu footer buttons -->
        </div>
      </div>

      <!-- top navigation -->
      <div class="top_nav no-print">
        <div class="nav_menu">
          <nav class="nav navbar-nav text-left pl-5">
            <div class="row">
              <div class="col-2">
                <div class="nav toggle float-right pt-2">
                  <a id="menu_toggle"
                    ><i
                      class="fa fa-bars"
                      style="font-size: 26px !important"
                    ></i
                  ></a>
                </div>
              </div>
              <div class="col-10">
                <ul
                  class="nav navbar-right bg-danger"
                  dir="ltr"
                  style="
                    display: contents;
                    -ms-flex-wrap: wrap;
                    flex-wrap: inherit;
                  "
                >
                  <li class="open" style="padding-left: 15px">
                    <a
                      href="javascript:;"
                      class="user-profile dropdown-toggle"
                      aria-haspopup="true"
                      id="navbarDropdown"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img src="/Template/NewMenu/img/userNew.jpg" alt="" />
                      <span class="mr-2"
                        >{{
                          this.$session.get("UserInfoNetPa").ozvName +
                          " " +
                          this.$session.get("UserInfoNetPa").ozvFamily
                        }}
                      </span>
                    </a>
                    <div
                      dir="rtl"
                      class="dropdown-menu dropdown-usermenu pull-right text-right"
                      style="top: 15px !important; left: -90px !important"
                    >
                      <!-- <a class="dropdown-item" href="javascript:;">راهنما</a> -->
                      <a
                        class="dropdown-item"
                        @click.prevent="LogOut()"
                        href="javascript:;"
                        ><i class="fa fa-sign-out float-left"></i> خروج</a
                      >
                    </div>
                  </li>
                  <li
                    v-if="GetCart > 0"
                    class="open"
                    style="padding-left: 15px"
                  >
                    <a
                      href="javascript:;"
                      class="user-profile"
                      @click="GoToCart()"
                      id="navbarDropdown"
                    >
                      <i
                        class="fas fa-shopping-bag text-danger bounce"
                        style="font-size: 18px !important"
                      ></i
                      ><b class="ml-2 text-danger">{{ GetCart }}</b>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
      <!-- top navigation -->

      <!-- page content -->
      <div class="right_col" role="main">
        <div class="">
          <div class="m-3 p-5" v-if="this.$route.name == 'Pishkhan'">
            <!-- <shortcut></shortcut> -->
          </div>
          <router-view></router-view>
        </div>
      </div>
      <!-- page content -->
      <footer>
        <!-- <div class="pull-right">
                    <router-link :to="{name:'ViewHistory'}" > [ نسخه  : {{this.$store.state.VersionSoftware}} ] </router-link>
                    <span class="text-default">[ سمت کاربر :  {{this.$session.get('UserInfo').gName}} ]</span>
                    <span> [ {{ this.$store.state.JalaliDateAndTime }} ] </span>
                </div> -->
        <div class="clearfix"></div>
      </footer>
    </div>
  </div>
</template>
<script>
// import Shortcut from '../Shortcuts/Shortcut.vue';

// import PanelForms from './PanelForms.vue';
export default {
  components: {},
  data() {
    return {
      render: true,
      Route: "",
      AllMenu: {},
      mainMenuLi: [],
      Pishkhan: {},
      UserIp: "",
      isWebSiteView: false,
    };
  },
  methods: {
    GotoModirShobe() {
      this.$session.set(
        "UserInfoNetPa",
        this.$session.get("UserInfoNetPaModirShobe"),
      );
      this.$session.set("UserInfoNetPaModirShobe", null);
      if (this.$router.name != "Home") {
        this.$router.push("/PishkhanNetPa/Home");
        window.location.reload();
      } else {
        window.location.reload();
      }
    },
    close() {
      document.getElementById("menu_toggle").click();
    },

    GoToPishkhan() {
      this.$router.push("/PishkhanNetPa");
    },
    GotoToTabloo() {
      this.$router.push("TablooElanat");
    },
    GoToSettingVam() {
      this.$router.push("SettingVam");
    },
    Getavatar() {
      return "/Image/avatar.jpg";
    },
    LogOut() {
      var DataAxios = {
        Method: "Post",
        Action: "Logout",
        ArryfildValue: {},
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(DataAxios).then((result) => {
        //console.log(result);
        this.$store.state.Netpa_Cart = [];
        this.$router.push("/");
        this.$session.clear();
        sessionStorage.removeItem("vuex");
        this.$store.state.PanelRout = [];
        this.$ResetTimer();
      });
    },
    GetMode() {
      var a = false;
      if (a == true) {
        return "left_col_Light scroll-view";
      } else {
        return "left_col scroll-view";
      }
    },
    GetMenus() {
      var result = this.$session.get("AllMenu");
      this.Pishkhan = result[0];
      result.forEach((element) => {
        if (element.params != null) {
          var withQuotes = element.params.replace(
            /(\b[a-z]+:)?(\b[a-z]+\b)/gi,
            '"$2"',
          );
          var parsed = JSON.parse(withQuotes);
          for (const [key, value] of Object.entries(parsed)) {
            if (value === "true") {
              parsed[key] = true;
            }
            if (value === "false") {
              parsed[key] = false;
            }
          }

          element.params = parsed;
        }
        this.AllMenu = result;
        if (element.isParentMenu == true) {
          this.mainMenuLi.push(element);
        }
      });
    },
    Getchild(id) {
      var childs = [];
      for (var i = 0; i < this.AllMenu.length; i++) {
        var element = this.AllMenu[i];
        if (element.parentId == id) {
          childs.push(element);
        }
      }
      return childs;
    },
    GoToCart() {
      if (this.$route.name != "Cart") {
        this.$router.push({
          name: "Cart",
        });
      }
    },
  },
  async created() {
    this.GetMenus();
    this.isWebSiteView = await this.$IsWebSiteView();
  },
  mounted() {
    this.$GetipClient()
      .then((data) => {
        this.UserIp = data.data.MyIP;
      })
      .catch(() => {
        this.UserIp = "127.0.0.1";
      });
    this.render = false;
    this.$nextTick(() => {
      this.render = true;
    });
  },
  computed: {
    GetCart() {
      var count = 0;
      let cart = this.$store.state.Netpa_Cart;
      for (let index = 0; index < cart.length; index++) {
        if (cart[index].item.length > 0) {
          count += cart[index].item.length;
        }
      }
      return count;
    },
  },
};
</script>
<style scoped>
@media print {
  .no-print {
    display: none !important;
  }
  /* .print {
    display: block !important;
  } */
}
.nav-sm .nav.side-menu li a span.font-small {
  /* white-space: nowrap !important; */
  font-size: 0.6rem !important;
  margin-right: 0 !important;
}

#app {
  font-size: 14px;
}

#app * {
  font-size: 12px !important;
  clear: both !important;
}

.wrapper {
  font-size: 12px !important;
}

.main-sidebar {
  z-index: 1000 !important;
  height: 100vh;
  overflow-y: hidden;
}

i.fa-circle-o {
  color: rgb(187, 145, 6) !important;
}

.menu-open > a {
  background: rgb(121, 93, 4) !important;
}

.dropdown-menu-lg {
  min-width: 170px;
  max-width: 300px;
  padding: 0;
  text-align: center;
}

.nav-sm .headerlogo {
  margin-right: 25% !important;
}

.Nohover:hover {
  background: #ededed;
}

#b_Timer {
  width: 62px;
  background-color: transparent;
  margin-top: 15px;
  color: #2a3f54;
  border: none;
  text-align: center;
  float: left;
  font-size: 14px !important;
  font-family: tahoma;
  left: 1px;
}

.pull-right {
  text-align: right;
}
</style>
<style>
/* width */

.bounce {
  -webkit-animation-name: bounceIn;
  animation-name: bounceIn;
  -webkit-animation-duration: 0.75s;
  animation-duration: 0.75s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
</style>
